import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private searchOrderNumber = new BehaviorSubject<string>(null);
  searchOrderNumber$ = this.searchOrderNumber.asObservable();
  private searchRequestNumber = new BehaviorSubject<string>(null);
  searchRequestNumber$ = this.searchRequestNumber.asObservable();
  private searchPlantName = new BehaviorSubject<string>(null);
  searchPlantName$ = this.searchPlantName.asObservable();
  private searchClientName = new BehaviorSubject<string>(null);
  searchClientName$ = this.searchClientName.asObservable();
  private searchAddress = new BehaviorSubject<string>(null);
  searchAddress$ = this.searchAddress.asObservable();
  private searchName = new BehaviorSubject<string>(null);
  searchName$ = this.searchName.asObservable();
  private searchPhone = new BehaviorSubject<string>(null);
  searchPhone$ = this.searchPhone.asObservable();
  private searchCarNumber = new BehaviorSubject<string>(null);
  searchCarNumber$ = this.searchCarNumber.asObservable();
  private searchCarrier = new BehaviorSubject<string>(null);
  searchCarrier$ = this.searchCarrier.asObservable();
  private searchStatus = new BehaviorSubject<string>(null);
  searchStatus$ = this.searchStatus.asObservable();
  private searchDeliveryStatus = new BehaviorSubject<string>(null);
  searchDeliveryStatus$ = this.searchDeliveryStatus.asObservable();

  constructor() {}

  public getSearchOrderNumber(value: string) {
    this.searchOrderNumber.next(value);
    console.log(value);
  }

  public getSearchRequestNumber(value: string) {
    this.searchRequestNumber.next(value);
    console.log(value);
  }

  public getSearchPlantName(value: string) {
    this.searchPlantName.next(value);
    console.log(value);
  }

  public getSearchClientName(value: string) {
    this.searchClientName.next(value);
    console.log(value);
  }

  public getSearchAddress(value: string) {
    this.searchAddress.next(value);
    console.log(value);
  }

  public getSearchName(value: string) {
    this.searchName.next(value);
  }

  public getSearchPhone(value: string) {
    this.searchPhone.next(value);
  }

  public getSearchCarNumber(value: string) {
    this.searchCarNumber.next(value);
  }

  public getSearchCarrier(value: string) {
    this.searchCarrier.next(value);
  }

  public getSearchStatus(value: string) {
    this.searchStatus.next(value);
  }

  public getSearchDeliveryStatus(value: string) {
    this.searchDeliveryStatus.next(value);
    console.log(value);
  }
}
